import gql from 'graphql-tag'

import { serverTaskFields } from './fragments'

export default gql`
query CA_web_listAutomationTaskServer {
	cashAssist {
		listAutomationTaskServer {
			...autoTasksServerFields
		}
	}
}
${serverTaskFields}`
